/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityhumorstylewest3Inputs */



/**
* | output |
* | --- |
* | "Sarcasman" |
*
* @param {Personalityhumorstylewest3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityhumorstylewest3 = /** @type {((inputs?: Personalityhumorstylewest3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityhumorstylewest3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Sarcasman")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sarcástico")
	return /** @type {LocalizedString} */ ("Сарказмен")
});
export { personalityhumorstylewest3 as "personalityHumorStyleWest" }